export var ServicePlanTypes;
(function (ServicePlanTypes) {
    ServicePlanTypes["BMW_CL_SERVICE_PLAN"] = "Plandeservicio";
    ServicePlanTypes["SUB_AU_SERVICE_PLAN"] = "serviceplans";
    ServicePlanTypes["MINI_CL_SERVICE_PLAN"] = "mini_plandeservicio";
})(ServicePlanTypes || (ServicePlanTypes = {}));
//# sourceMappingURL=ServicePlanTypes.js.map